module.exports = __webpack_public_path__ + "static/media/whitepaper8.de196fa8.png";